import { motion } from "framer-motion";
import { SpecimenLabel } from "../SpecimenLabel";
import { LiveExtractionDemo } from "../LiveExtractionDemo";

export const FrameLiveExtraction = () => {
  return (
    <section id="live-extraction" className="py-24 px-4 sm:px-6 lg:px-8 bg-muted/10">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <SpecimenLabel text="LIVE DEMO" className="mb-4 block" />
          <h2 className="font-editorial text-3xl md:text-4xl text-foreground mb-4">
            Try the extraction.
          </h2>
          <p className="text-xl text-muted-foreground">
            No signup. No tricks. Paste any testimonial. Watch it transform.
          </p>
        </motion.div>

        <LiveExtractionDemo />
      </div>
    </section>
  );
};
